module.exports = __webpack_public_path__ + "static/media/file-delete.3d24b4b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/file-delete.svg
// module id = 70
// module chunks = 0